import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import Entity from "../datasource/Entity";
import clientConfig from "../config/client";
import { Box } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Official from "../components/Views/Official.jsx";
import AltText from "../components/Views/AltText.jsx";
import UpdateMB from "../components/Views/UpdateMB.jsx";

class OfficialContainer extends Container {
    constructor(props) {
        super(props);
    }

    render = () => {
        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }

        let official = (
            <Box mt={4}>
                <LinearProgress mt={3} />
            </Box>
        );

        const hotelsWorkIds = import.meta.env.VITE_API_HOTELS_WORK_IDS
            ? import.meta.env.VITE_API_HOTELS_WORK_IDS.split(',').map(id => +id)
            : [];

        if (true) {
            official = (
                <>
                    {!hotelsWorkIds.includes(12) &&
                        <>
                            <Official/>
                            <UpdateMB/>
                        </>
                    }
                    <AltText hotelId={this.props.match.params.mainId} />
                </>
            );
        }

        return (
            <Paper elevation={3}>
                <Box p={3}>
                    <Typography mb={3} variant={"h5"}>
                        Служебные
                    </Typography>
                </Box>
                {official}
            </Paper>
        );
    };
}

export default OfficialContainer;
